import { render, staticRenderFns } from "./daily.vue?vue&type=template&id=2d9dc0ee&scoped=true"
import script from "./daily.vue?vue&type=script&lang=js"
export * from "./daily.vue?vue&type=script&lang=js"
import style0 from "./daily.vue?vue&type=style&index=0&id=2d9dc0ee&lang=css"
import style1 from "./daily.vue?vue&type=style&index=1&id=2d9dc0ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9dc0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9dc0ee')) {
      api.createRecord('2d9dc0ee', component.options)
    } else {
      api.reload('2d9dc0ee', component.options)
    }
    module.hot.accept("./daily.vue?vue&type=template&id=2d9dc0ee&scoped=true", function () {
      api.rerender('2d9dc0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/daily.vue"
export default component.exports